import React from 'react';
import TrackerPage from '../components/TrackerPage';
import useTrackerAccess from '../hooks/useTrackerAccess';
import { CARD, VIEWS } from '../utils/trackerConstants';

const CARDS = [{ ...CARD.total, title: 'Assigned To Me' }, CARD.awaitingTutor, CARD.newTutorAssigned, CARD.pending, CARD.retained, CARD.tutorChange];

// TA associate: the replacements their head assigned to them; the only action is the progress update.
export default function TaAssociateReplacements() {
  const access = useTrackerAccess();

  return (
    <TrackerPage
      view={VIEWS.MINE}
      title={'My Tutor Replacements'}
      cards={CARDS}
      blocked={access.loaded && !access.isTaWing ? 'Only the TA wing has assigned replacements.' : ''}
    />
  );
}
